export default __webpack_public_path__ + "static/media/MencionEspecial.b6667db8.svg";